export default __webpack_public_path__ + "static/media/hotel6.7922666e.jpg";